import * as ko from "knockout";
import template from './PageHeader.html';
import { Country } from "../localization";

class PageHeader {

  languages: ko.ObservableArray<Country> = ko.observableArray();
  selectedLangCode: ko.Observable<string>;
  selectLanguageText: ko.Observable<string> = ko.observable<string>("");
  logoUri: ko.Observable<string> = ko.observable<string>("");
  logoAlt: ko.Observable<string> = ko.observable<string>("Logo");

  // Computed properties - initialized in constructor
  selectedLanguage: ko.PureComputed<string>;

  constructor() {
    global.Logonme.log(`PageHeader: constructor, initial language = ${global.Logonme.SelectedLanguage()}`);

    // Initialize computed properties
    this.selectedLanguage = ko.pureComputed<string>(() => global.Logonme.SelectedLanguage());

    // Populate languages array FIRST
    const localizations = global.Logonme.LocalizationManager.getLocalizations();
    for (let i = 0; i < localizations.length; i++) {
      this.languages.push(localizations[i]);
    }

    // Initialize as simple observable with current language
    this.selectedLangCode = ko.observable<string>(global.Logonme.SelectedLanguage());

    // Subscribe to changes from the select element
    this.selectedLangCode.subscribe((value: string) => {
      global.Logonme.log(`PageHeader.selectedLangCode changed: ${value}, global=${global.Logonme.SelectedLanguage()}`);
      if (value && value !== global.Logonme.SelectedLanguage()) {
        global.Logonme.log(`PageHeader: Setting global language from ${global.Logonme.SelectedLanguage()} to ${value}`);
        global.Logonme.SelectedLanguage(value);
      }
    });

    // Subscribe to changes from global (e.g., from other components)
    this.selectedLanguage.subscribe((lang: string) => {
      global.Logonme.log(`PageHeader: global language changed to ${lang}, updating select`);
      if (this.selectedLangCode() !== lang) {
        this.selectedLangCode(lang);
      }
      this.updateStrings(lang);
    });

    // Set up initial strings
    this.updateStrings(this.selectedLanguage());
  }

  private updateStrings(lang: string): void {
    this.selectLanguageText(global.Logonme.LocalizationManager.getText('header-select-language', lang));
    const logoFile = global.Logonme.LocalizationManager.getText('header-logo-uri', lang, '');
    this.logoUri(logoFile ? `${global.Logonme.Configuration.baseUrl}/ls/${global.Logonme.Configuration.tenant}/asset/${logoFile}` : '');
    this.logoAlt(global.Logonme.LocalizationManager.getText('header-logo-alt', lang, 'Logo'));
  }
}

export default { viewModel: PageHeader, template: template };
